export const isWorkOrderOpen = (workOrder) => workOrder.status === "Active" || workOrder.status === "Created";

export const isWorkOrderClosed = (workOrder) => !isWorkOrderOpen(workOrder);

export const isWorkOrderItemOpen = (workItem) => !workItem.isCompleted;

export const isWorkOrderItemClosed = (workItem) => !isWorkOrderItemOpen(workItem);
